export default __webpack_public_path__ + "static/media/img_step_hami07.163fc511.jpg";